import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

const initialState = {
  data: [],
  total: 0,
  limit: 50,
  page: 1,
  loading: false,
  error: null,
  matchDetail: {
    data: [],
    loading: false,
    error: null,
  },
};

export const fetchLedgerAsync = createAsyncThunk(
  "ledger/fetchLedger",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/report/eventsProfitLoss",
        payload || {},
      );
      if (!response?.status) {
        return rejectWithValue(response?.message || "Failed to fetch ledger");
      }
      return { response, payload };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch ledger",
      );
    }
  },
);

export const fetchMatchDetailAsync = createAsyncThunk(
  "ledger/fetchMatchDetail",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/bet/settledBets", payload);
      if (!response?.status) {
        return rejectWithValue(
          response?.message || "Failed to fetch match detail",
        );
      }
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch match detail",
      );
    }
  },
);

const ledgerSlice = createSlice({
  name: "ledger",
  initialState,
  reducers: {
    clearLedger: (state) => {
      state.data = [];
      state.total = 0;
      state.limit = 50;
      state.page = 1;
      state.error = null;
    },
    clearMatchDetail: (state) => {
      state.matchDetail = { data: [], loading: false, error: null };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLedgerAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLedgerAsync.fulfilled, (state, action) => {
        state.loading = false;
        const response = action.payload?.response;

        const dataGroup = response?.data;
        const rawData = dataGroup?.data || [];
        const metadata = dataGroup?.metadata || {};

        state.data = rawData.map((item) => ({
          ...item,
          date: item.match_date,
          won_by: item.winner_name,
          won: item.net_pl > 0 ? item.net_pl : 0,
          lost: item.net_pl < 0 ? Math.abs(item.net_pl) : 0,
          balance: item.user_pl,
        }));

        state.total = metadata?.total || 0;
        state.limit = metadata?.limit || state.limit;
        state.page = metadata?.page || 1;
        state.error = null;
      })
      .addCase(fetchLedgerAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchMatchDetailAsync.pending, (state) => {
        state.matchDetail.loading = true;
        state.matchDetail.error = null;
      })
      .addCase(fetchMatchDetailAsync.fulfilled, (state, action) => {
        state.matchDetail.loading = false;
        const response = action.payload;
        const dataGroup = response?.data?.[0];
        const metadata = dataGroup?.metadata?.[0];

        state.matchDetail.data = dataGroup?.data || [];
        state.matchDetail.total = metadata?.total || 0;
        state.matchDetail.limit = metadata?.limit || state.limit;
        state.matchDetail.page = metadata?.page || 1;
        state.matchDetail.error = null;
      })
      .addCase(fetchMatchDetailAsync.rejected, (state, action) => {
        state.matchDetail.loading = false;
        state.matchDetail.error = action.payload;
      });
  },
});

export const { clearLedger, clearMatchDetail } = ledgerSlice.actions;
export default ledgerSlice.reducer;
